import { z } from "zod";

const httpUrl = z.string().regex(/^https?:\/\//i);

export const CoachSchema = z.object({
  name: z.string().min(1),
  avatarUrl: httpUrl.nullable().optional(),
  // TeachMe.To Partner API link, used exactly as sent: its query string is what
  // credits the booking to us, so it must never be rewritten.
  bookingUrl: httpUrl,
  // Per-lesson rate when buying a 10-pack, not the price of one lesson.
  startingPrice: z.number(),
  // 0–5 stars.
  rating: z.number().nullable().optional(),
  reviewCount: z.number().nullable().optional(),
  distanceMiles: z.number().nullable().optional(),
  certification: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  description: z.string().default(""),
});

export const CoachResultSchema = z.object({
  coaches: z.array(CoachSchema).min(1),
});

export type Coach = z.infer<typeof CoachSchema>;
export type CoachResult = z.infer<typeof CoachResultSchema>;

export function validateCoachResult(value: unknown): CoachResult | null {
  const parsed = CoachResultSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
